import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { Col, Input, Row } from 'reactstrap';
import {
    MODE_CUSTOM,
    MODE_NOMAIL,
    MODE_NONE,
    mode_from_override_to,
    value_from_mode,
} from './emailOverrideTo';

import './EmailOverrideToField.css';

const EmailOverrideToField = ({ name, defaultValue, form }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [mode, setMode] = useState(() => mode_from_override_to(defaultValue));
    const [customEmail, setCustomEmail] = useState(() => (
        mode_from_override_to(defaultValue) === MODE_CUSTOM
            ? String(defaultValue || '')
            : ''
    ));

    useEffect(() => {
        const nextMode = mode_from_override_to(defaultValue);
        setMode(nextMode);
        if (nextMode === MODE_CUSTOM)
            setCustomEmail(String(defaultValue || ''));
    }, [defaultValue]);

    useEffect(() => {
        dispatch(change(form, name, value_from_mode(mode, customEmail)));
    }, [customEmail, dispatch, form, mode, name]);

    return (
        <div className="EmailOverrideToField">
            <Row>
                <Col>
                    <Input
                        type="select"
                        className="form-control"
                        value={mode}
                        onChange={(e) => setMode(e.target.value)}
                    >
                        <option value={MODE_NONE}>
                            {t('settings.customer.email.override_to_none')}
                        </option>
                        <option value={MODE_NOMAIL}>
                            {t('settings.customer.email.override_to_nomail')}
                        </option>
                        <option value={MODE_CUSTOM}>
                            {t('settings.customer.email.override_to_custom')}
                        </option>
                    </Input>
                </Col>
            </Row>
            {mode === MODE_CUSTOM && (
                <Row className="EmailOverrideToField-email mt-2">
                    <Col>
                        <Input
                            type="email"
                            className="form-control email"
                            value={customEmail}
                            onChange={(e) => setCustomEmail(e.target.value)}
                            onInvalid={(e) => e.target.setCustomValidity(t('users.invalid_email'))}
                            onInput={(e) => e.target.setCustomValidity('')}
                            placeholder={t('users.email_placeholder')}
                        />
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default EmailOverrideToField;
